import routerOptions0 from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/node_modules/.pnpm/nuxt@3.21.10_@oxc-project+types@0.140.0_@parcel+watcher@2.5.6_@types+node@24.6.1_@vue+c_01e2ab469303ae64dc334d479b301b0c/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}